import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get_appointment_by_client_id } from "../../store/reducers/appointmentReducerClient";
import { format } from "date-fns";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { FaCopy } from "react-icons/fa6";
import { delete_appointment } from "../../store/reducers/appointmentReducerClient";

const Appointments = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const userId = userInfo.id;
  const { clientAppt } = useSelector((state) => state.appointmentsClient);

  const [state, setState] = useState("all");
  const [sortedAppt, setSortedAppt] = useState([]);
  const [selectedAppt, setSelectedAppt] = useState(null);
  const [deletePopup, setDeletePopup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(get_appointment_by_client_id(userId));
  }, [userId, dispatch]);

  useEffect(() => {
    let filtered = [...clientAppt];

    // Filter by appointmentStatus if state is not "all"
    if (state !== "all") {
      filtered = filtered.filter((appt) => appt.appointmentStatus === state);
    }

    // Sort from newest to oldest by slotDate
    filtered.sort((a, b) => new Date(b.slotDate) - new Date(a.slotDate));

    setSortedAppt(filtered);
  }, [clientAppt, state]);

  const handleApptClick = (appt) => {
    setSelectedAppt(appt);
  };

  const closeDetails = () => {
    setSelectedAppt(null);
  };

  const handleDeletePopupOpen = () => setDeletePopup(!deletePopup);

  const handleDeleteAppointment = async () => {
    await dispatch(delete_appointment(selectedAppt._id));
    setDeletePopup(false);
    closeDetails();
    setTimeout(() => {
      dispatch(get_appointment_by_client_id(userId));
    }, 2000);
  };

  const handleCopy = (id) => {
    navigator.clipboard
      .writeText(id)
      .then(() => {
        toast.success("ID copié avec succès - تم نسخ المعرف بنجاح");
      })
      .catch(() => {
        toast.error("Échec de la copie de l'ID");
      });
  };
  return (
    <div className="bg-white p-4 rounded-md">
      <div className="flex justify-between items-center">
        <h2 className="text-xl sm:text-sm font-semibold text-slate-600">
          Mes Rendez-Vous
        </h2>
        <select
          className="outline-none px-3 py-1 border rounded-md text-slate-600"
          value={state}
          onChange={(e) => setState(e.target.value)}
        >
          <option value="all">-Tous 📋-</option>
          <option value="pending">En attente</option>
          <option value="accepted">Accepté</option>
          <option value="done">Terminé</option>
          <option value="refused">Refusé</option>
        </select>
      </div>
      <div className="pt-4">
        <div className="relative overflow-x-auto overflow-y-auto max-h-[600px]">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3">
                  ID
                </th>
                <th scope="col" className="px-3 py-3">
                  Date
                </th>
                <th scope="col" className="px-3 py-3">
                  Heure
                </th>
                <th scope="col" className="px-3 py-3">
                  Prix
                </th>
                <th scope="col" className="px-3 py-3">
                  Durée
                </th>
                <th scope="col" className="px-3 py-3">
                  Docteur
                </th>
                <th scope="col" className="px-3 py-3">
                  Paiement
                </th>
                <th scope="col" className="px-3 py-3">
                  Statut
                </th>
                <th scope="col" className="px-3 py-3">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedAppt.map((r, i) => (
                <tr key={i} className="bg-white border-b">
                  <td className=" py-1 font-medium flex justify-center items-center ">
                    <div className="flex justify-center items-center bg-mainBg rounded-md border-2 border-[#00eafb]">
                      <p className=" px-2 ">{r._id}</p>
                      <span
                        onClick={() => handleCopy(r._id)}
                        className="bg-[#00eafb] p-1 w-full h-full rounded-r-md cursor-pointer text-slate-600"
                      >
                        {" "}
                        <FaCopy className=" text-2xl " />{" "}
                      </span>
                    </div>
                  </td>
                  <td className="px-3 py-2 font-medium whitespace-nowrap">
                    {format(new Date(r.slotDate), "dd-MM-yyyy")}
                  </td>
                  <td className="px-3 py-2 font-medium whitespace-nowrap">
                    {r.slotTime}
                  </td>
                  <td className="px-3 py-2 font-medium whitespace-nowrap">
                    {r.amount} DA
                  </td>
                  <td className="px-3 py-2 font-medium whitespace-nowrap">
                    {r.duration} min
                  </td>
                  <td className="px-3 py-2 font-medium whitespace-nowrap">
                    {r.doctorData.name}
                  </td>
                  <td
                    className={`px-3 py-2 font-medium whitespace-nowrap border-r-2 ${
                      r.payment === true ? "bg-green-300" : "bg-yellow-100"
                    }`}
                  >
                    {r.payment === true ? "Payé" : "En attente"}
                  </td>
                  <td
                    className={`px-3 py-2 font-medium whitespace-nowrap ${
                      r.appointmentStatus === "done"
                        ? "bg-green-300"
                        : r.appointmentStatus === "pending"
                        ? "bg-yellow-100"
                        : r.appointmentStatus === "accepted"
                        ? "bg-blue-300"
                        : r.appointmentStatus === "refused"
                        ? "bg-orange-300"
                        : ""
                    }`}
                  >
                    {r.appointmentStatus === "done"
                      ? "Terminé"
                      : r.appointmentStatus === "pending"
                      ? "En attente"
                      : r.appointmentStatus === "accepted"
                      ? "Accepté"
                      : r.appointmentStatus === "refused"
                      ? "Refusé"
                      : ""}
                  </td>
                  <td className="px-3 py-2">
                    <button
                      onClick={() => handleApptClick(r)}
                      className="bg-mainBg text-green-800 text-sm font-normal mr-2 px-3.5 py-1 rounded border-r-2 border-[#00eafb]"
                    >
                      Voir
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {selectedAppt && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 backdrop-blur-md">
          <div className="bg-mainBg p-6 rounded-xl shadow-lg w-[40%] lg:w-[95%]">
            <h2 className="text-lg md:text-sm font-semibold mb-6 text-center">
              Détails du Rendez-vous
            </h2>
            <div className="flex justify-center items-center mb-2">
              <p>ID:</p>
              <div className="flex justify-center items-center ml-3 bg-mainBg rounded-md border-2 border-[#00eafb]">
                <p className=" px-2 ">{selectedAppt._id}</p>
                <span
                  onClick={() => handleCopy(selectedAppt._id)}
                  className="bg-[#00eafb] p-1 w-full h-full rounded-r-md cursor-pointer text-slate-600"
                >
                  {" "}
                  <FaCopy className=" text-2xl " />{" "}
                </span>
              </div>
            </div>
            <div className="bg-slate-50 p-2 rounded-md mb-6">
              <p>Heure: {selectedAppt.slotTime}</p>
              <p>
                Date: {format(new Date(selectedAppt.slotDate), "dd-MM-yyyy")}
              </p>
              <p>Prix: {selectedAppt.amount} DA</p>
              <p>Durée: {selectedAppt.duration} min</p>
              <hr className="my-2" />
              <p>Client: {selectedAppt.userData.name}</p>
              <p>Email: {selectedAppt.userData.email}</p>
              <p>Telephone: {selectedAppt.userData.phone}</p>
              <p>Sex: {selectedAppt.userData.gender}</p>
              <p>Age: {selectedAppt.userData.name}</p>
              <p>Message: {selectedAppt.userData?.message || "..."}</p>
              <hr className="my-2" />
              <p>Docteur: {selectedAppt.doctorData.name}</p>
              <p>Email: {selectedAppt.doctorData.email}</p>
              <p>Telephone: {selectedAppt.doctorData.phone}</p>
              <p>Wilaya: {selectedAppt.doctorData.wilaya}</p>
              <p>Commune: {selectedAppt.doctorData.commune}</p>

              <p>
                Statut:{" "}
                {selectedAppt.appointmentStatus === "done"
                  ? "Terminé ✅"
                  : selectedAppt.appointmentStatus === "pending"
                  ? "En attente ⏳"
                  : selectedAppt.appointmentStatus === "accepted"
                  ? "Accepté ✔️"
                  : selectedAppt.appointmentStatus === "refused"
                  ? "Refusé ❌"
                  : ""}
              </p>
            </div>

            <div className="flex justify-between mt-6">
              <button onClick={closeDetails} className="second-btn ">
                غلق
              </button>
              <button onClick={handleDeletePopupOpen} className="main-btn2">
                إلغاء الموعد
              </button>
            </div>
          </div>
        </div>
      )}
      {deletePopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 backdrop-blur-md">
          <div className="bg-mainBg backdrop-blur-[6px] p-6 rounded-xl shadow-lg w-[40%] lg:w-[95%]">
            <p>
              Etes-vous sûr de vouloir supprimer le rendez-vous du Client :{" "}
              {selectedAppt.userData.name},{" "}
              {format(selectedAppt.slotDate, "dd-MM-yyyy")} a{" "}
              {selectedAppt.slotTime}?
            </p>
            <p className=" flex justify-end">
              <span>
                {selectedAppt.slotTime} -
                {format(selectedAppt.slotDate, "dd-MM-yyyy")} -{" "}
                {selectedAppt.userData.name} :{" "}
              </span>
              <span>هل أنت متأكد أنك تريد حذف موعد العميل</span>
            </p>
            <p className="flex my-3">
              <span className="bg-slate-100  border border-[#198288] px-2 py-1 rounded-md">
                ID: {selectedAppt._id}
              </span>
            </p>
            <div className="flex justify-between mt-3">
              <button className="second-btn" onClick={handleDeletePopupOpen}>
                Non - لا
              </button>
              <button className="main-btn2" onClick={handleDeleteAppointment}>
                Oui - نعم
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Appointments;
